/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Sendemail2Inputs */

const en_coinvestments_error_sendemail2 = /** @type {(inputs: Coinvestments_Error_Sendemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send email`)
};

/**
* | output |
* | --- |
* | "Failed to send email" |
*
* @param {Coinvestments_Error_Sendemail2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_sendemail2 = /** @type {((inputs?: Coinvestments_Error_Sendemail2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Sendemail2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_sendemail2(inputs)
});
export { coinvestments_error_sendemail2 as "coInvestments_error_sendEmail" }